import React from 'react';
import PropTypes from 'prop-types';
import { useFeatureFlag } from '@americanexpress/one-experiments';
import { useSelector } from 'react-redux';
import { getActiveLocaleSelector, getTenancySelector } from '@americanexpress/travel-selectors';
import { RenderModule } from 'holocron';
import { useConditionalFeature } from '@americanexpress/conditional-features';
import { Heading } from '@americanexpress/dls-react';
import { hasUnusedCreditRule } from '../../constants/featureRulesConstants';
import style from './Hero.scss';
import getLineOfBusinessFromPath from '../../utils/getLineOfBusinessUtils';
import AbandonHotel from '../AbandonHotel/AbandonHotel';
import {
  MODULE_NAME, ADVISORY_MODULE_NAME, SEARCH_MODULE_NAME, UNUSED_TICKETS_MODULE_NAME,
} from '../../constants/modules';
import { useDataFromOneCms } from '../../fetchye/useOneCmsFetchye';
import {
  DISABLE_PACKAGES_FF,
  E_TICKET_BANNER_FF,
} from '../../constants/oneXpConstants';
import { HOTELS } from '../../constants/lineOfBusinessConstants';

const VariantHero = ({
  selectedTab,
  setSelectedTab,
  isLoggedIn,
  pathname,
}) => {
  const tenancy = useSelector(getTenancySelector);
  const locale = useSelector(getActiveLocaleSelector);
  const { properties: packagesFFProperties } = useFeatureFlag(
    { featureFlagName: DISABLE_PACKAGES_FF });
  const isPackagesDisabledByFF = packagesFFProperties?.[tenancy]?.includes(locale);
  const { properties: eTicketBannerFFProperties } = useFeatureFlag(
    { featureFlagName: E_TICKET_BANNER_FF });
  const isETicketBannerDisplayedByFF = eTicketBannerFFProperties?.[tenancy]?.includes(locale);
  const hasUnusedCredit = useConditionalFeature(hasUnusedCreditRule);

  const dataFromOneCms = useDataFromOneCms('hero');
  const { header } = dataFromOneCms?.[selectedTab || HOTELS] || {};

  return (
    <div data-testid={`${MODULE_NAME}-hero-variant-no-image`} className={style.variantHero}>
      <div className="flex flex-column flex-align-items-center container pad-0-lr-xs-down pad-4-tb-sm-up margin-2-b-sm-up">
        <RenderModule moduleName={ADVISORY_MODULE_NAME} />
        <AbandonHotel extraDlsStyles="pad-0" />
        <div className={`dls-white-bg flex flex-column pad-3 pad-2-t-sm-up width-full margin-t-sm-up ${style.searchBlock}`}>
          <Heading level={1} variant="serif-large-regular" className="flex flex-align-self-center text-align-center">
            {header}
          </Heading>
          <RenderModule
            moduleName={SEARCH_MODULE_NAME}
            props={{
              theme: 'white',
              activeTab: getLineOfBusinessFromPath(isPackagesDisabledByFF, pathname),
              onActiveTabChange: setSelectedTab,
            }}
          />
        </div>
        {(isLoggedIn && isETicketBannerDisplayedByFF && hasUnusedCredit) && (
          <div className="width-full">
            <RenderModule moduleName={UNUSED_TICKETS_MODULE_NAME} />
          </div>
        )}
      </div>
    </div>
  );
};

VariantHero.propTypes = {
  selectedTab: PropTypes.string.isRequired,
  setSelectedTab: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  pathname: PropTypes.string.isRequired,
};

export default VariantHero;
